import Vue from 'vue';
/**
  Renders a toggle slider.

  Example usage from a parent component:

     <div class="field">
         <toggle-slider v-model="sentimentEnabled">
             Enable Sentiment Identification
         </toggle-slider>
     </div>

 */
export default Vue.extend({
    props: {
        value: { type: Boolean, required: false, default: false },
        label: { type: String, required: false, default: '' },
        disabled: { type: Boolean, required: false, default: false },
        showCheckbox: { type: Boolean, required: false, default: true },
        errors: { type: Array, required: false, default: () => [] },
    },
    computed: {
        hasLabel() {
            return !!this.$slots;
        },
        errored() {
            return this.errors && this.errors.length > 0;
        }
    }
});
